import React from 'react';

export const legalTextFirst = (
  <p>
    El Grupo Atresmedia cuenta con un
    <strong> Modelo de Cumplimiento Normativo y Prevención Penal </strong>
    que es aplicable a todos sus empleados, que deben conocerlo y aplicarlo en
    su actividad y relaciones profesionales con colaboradores externos y
    terceros. El Código de Conducta de Atresmedia y el Protocolo Anticorrupción
    junto con el Canal de Consultas y Denuncias, son piezas esenciales de este
    Modelo, pues recogen los principios, objetivos y valores fundamentales que
    deben guiar el comportamiento de quienes trabajan o colaboran con las
    empresas del Grupo.
  </p>
);

export const legalTextSecond = (
  <p>
    Por otra parte, Atresmedia tiene un
    <strong>
      {' '}
      Modelo de Cumplimiento de la normativa de Protección de Datos{' '}
    </strong>
    que incluye una serie de políticas, procedimientos que recogen los objetivos
    y principios del Grupo en esta materia, que deben regir sus actuaciones, las
    de sus empleados y colaboradores, así como unas herramientas de seguimiento
    y control.
  </p>
);

export const legalTextThird = (
  <p>
    El Grupo cuenta con una Delegada de Protección de Datos (DPO) con la que se
    debe consultarse cualquier aspecto relacionado con la privacidad de los
    datos y su tratamiento a través del correo electrónico:{' '}
    <a href="privacidad@atresmedia.com">privacidad@atresmedia.com</a>{' '}
  </p>
);
export const legalTextFourth = (
  <p>
    Te invitamos a visitar las secciones “Cumplimiento Normativo” y “Protección
    de Datos” situadas en el desplegable de la cabecera. En estas secciones,
    encontrarás toda la información, completa y actualizada, sobre el sistema de
    gobierno de ambos Modelos, las políticas y protocolos aplicables y los
    mecanismos establecidos para su adecuado funcionamiento, junto con las
    formas de acceso y de uso, así como recursos formativos, tanto en materia de
    prevención penal como en privacidad.
  </p>
);

export const legalTextFifth = (
  <p>
    Puedes consultar en cualquier momento la Política de Privacidad aplicable al
    tratamiento de tus datos personales en la sección “Protección de Datos”.
  </p>
);

export const legalTextExternalUsersTtile = <h5>AVISO</h5>;

export const legalTextExternalUsers = (
  <p>
    El acceso al espacio de intranet se realiza por personas a las que se ha
    concedido de manera especifica permiso para ello, sin que dicha autorización
    implique ningún cambio en la relación que estas personas puedan tener con la
    empresa, ni afecte al vínculo legal que les unen. <br />
    En todos los sentidos se trata de un permiso de acceso como usuario
    específicamente conocido y autorizado por los gestores de la presente página
    Web y no tiene más alcance que acceder a la intranet de Atresmedia como
    usuarios de la misma.
  </p>
);

export const legalExternalTextFirst = (
  <p>
    Atresmedia cuenta con un
    <strong> Modelo de Cumplimiento Normativo y Prevención Penal </strong>y con
    un<strong> Código de Conducta, </strong>
    que todas las personas que colaboran con el Grupo deben conocer, ya que
    recogen los principios y valores que deben guiar su relación con Atresmedia.
    Dispone además de un <strong>Canal de Consultas y Denuncias </strong> que
    permite comunicar cualquier irregularidad dentro de su ámbito de aplicación,
    de forma confidencial o anónima, a elección de la persona informante. El
    canal está disponible tanto en la intranet como en la web corporativa:
    <a href="https://www.atresmediacorporacion.com">
      www.atresmediacorporacion.com
    </a>
    .
  </p>
);

export const legalExternalTextSecond = (
  <p>
    Atresmedia dispone también de un{' '}
    <strong>Modelo de Cumplimiento en materia de Protección de Datos,</strong>{' '}
    que integra las políticas y procedimientos destinados a garantizar el
    tratamiento responsable y seguro de la información personal conforme a la
    normativa vigente. Puedes dirigirte a la{' '}
    <strong>Delegada de Protección de Datos (DPO)</strong> del Grupo para
    resolver cualquier cuestión relacionada con privacidad a través del correo
    electrónico:{' '}
    <a href="mailto:privacidad@atresmedia.com">privacidad@atresmedia.com</a>.
  </p>
);

export const legalExternalTextThird = (
  <p>
    Si accedes a la intranet en calidad de usuario externo, te recordamos que
    debes respetar las políticas y protocolos de privacidad y seguridad de
    Atresmedia, así como tratar los datos personales únicamente para las
    finalidades autorizadas y conforme a las instrucciones recibidas.
  </p>
);

export const legalExternalTextFourth = (
  <p>
    Te invitamos a visitar las secciones “Cumplimiento Normativo” y “Protección
    de Datos” disponible en el desplegable de la cabecera, donde encontrarás las
    políticas y procedimientos aplicables en estas materias y recursos
    formativos, así como la{' '}
    <strong>Política de Privacidad para Usuarios Externos,</strong> que podrás
    consultar en cualquier momento y que resulta aplicable al tratamiento de tus
    datos personales.
  </p>
);

export const legalExternalTextFifth = (
  <>
    <p>
      El acceso al espacio de intranet se realiza por personas a las que se ha
      concedido de manera específica permiso para ello, sin que dicha
      autorización implique ningún cambio en la relación que estas personas
      puedan tener con la empresa, ni afecte al vínculo legal que les unen.
    </p>
    <p>
      En todos los sentidos se trata de un permiso de acceso como usuario
      específicamente conocido y autorizado por los gestores de la presente
      página Web y no tiene más alcance que acceder a la intranet de Atresmedia
      como usuarios de la misma.
    </p>
  </>
);
